const en = {
  nav: {
    home: "Home",
    shop: "Shop",
    map: "Map",
    calculator: "Savings",
    compatibility: "Compatibility",
    about: "About Us",
    howItWorks: "How it Works",
    faq: "FAQ",
    contact: "Contact",
    cart: "Cart"
  },
  hero: {
    title: "Stay Connected Anywhere",
    subtitle: "Instant eSIM activation for 190+ countries. No physical SIM needed.",
    searchPlaceholder: "Where are you traveling?",
    cta: "Browse All eSIMs",
    searchHint: "Search a country or click on globe dots",
    exploreMap: "Explore Map",
    tagline1: "Connected instantly. No SIM shops, no waiting.",
    tagline2: "Forget WiFi hunting. Your eSIM keeps you online.",
    tagline3: "Share every moment. Always connected abroad.",
    tagline4: "Land and connect. eSIM ready before you arrive.",
    tagline5: "Navigate like a local. Data everywhere you go.",
    tagline6: "No more roaming fees. Just pure connection.",
    tagline7: "Stay connected in 209+ countries worldwide.",
    destinations: "Destinations",
    coverage: "Coverage",
    instantDelivery: "Instant Delivery"
  },
  products: {
    title: "Popular Destinations",
    viewAll: "View All",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    viewPlans: "View Plans",
    data: "Data",
    validity: "Validity",
    countries: "countries",
    from: "from",
    topDestinations: "Top Destinations",
    topDestinationsDesc: "The most requested destinations by our customers. Connect anywhere in the world.",
    discoverAll: "Discover all 213+ destinations",
    compareHint: "Click the scale icon to compare plans",
    filters: {
      all: "All",
      europe: "Europe",
      asia: "Asia",
      northAmerica: "N. America",
      southAmerica: "S. America",
      middleEast: "Middle East",
      africa: "Africa",
      caribbean: "Caribbean",
      oceania: "Oceania"
    }
  },
  features: {
    title: "Why Choose Us",
    instant: { title: "Instant Activation", desc: "Get connected in minutes. Scan QR code and you're ready to go." },
    global: { title: "Global Coverage", desc: "190+ countries covered. One eSIM, endless possibilities." },
    savings: { title: "Save up to 90%", desc: "No roaming fees. Transparent pricing with no hidden costs." },
    support: { title: "24/7 Support", desc: "Our team is here to help you anytime, anywhere." }
  },
  howItWorks: {
    title: "How It Works",
    step1: { title: "Choose Your Plan", desc: "Select your destination and data plan" },
    step2: { title: "Receive eSIM", desc: "Get QR code instantly via email" },
    step3: { title: "Scan & Connect", desc: "Scan with your phone and enjoy the internet" }
  },
  cart: {
    title: "Your Cart",
    empty: "Your cart is empty",
    total: "Total",
    checkout: "Proceed to Checkout",
    remove: "Remove",
    continueShopping: "Continue Shopping"
  },
  checkout: {
    title: "Checkout",
    billing: "Billing Information",
    payment: "Payment Method",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    city: "City",
    country: "Country",
    postalCode: "Postal Code",
    placeOrder: "Place Order",
    processing: "Processing...",
    creditCard: "Credit Card",
    paypal: "PayPal",
    acceptTerms: "I accept the Terms and Conditions",
    couponCode: "Coupon Code",
    travelBundle: "Travel Bundle",
    upsellFrom: "from",
    upsellAdd: "Add",
    applyCoupon: "Apply",
    couponApplied: "Coupon applied!",
    discount: "Discount",
    subtotal: "Subtotal",
    orderSummary: "Order Summary",
    securePayment: "Secure payment with",
    eurPaymentNote: "Payment processed in EUR ({{amount}}). Your bank will convert to your local currency.",
    orderConfirmed: "Your order has been confirmed. You will receive the eSIM QR code via email.",
    totalPaid: "Total paid",
    orderPlaced: "Order placed successfully!",
    orderNumber: "Order",
    receiveQR: "You will receive your eSIM QR code via email shortly.",
    orderTotal: "Order Total",
    verificationExpired: "Verification expired",
    paymentFailed: "Payment failed",
    verificationExpiredDesc: "We could not verify the payment. Check your email for confirmation.",
    paymentFailedDesc: "The payment did not go through. Please try again.",
    backToCheckout: "Back to Checkout",
    cardBrands: "Visa, Mastercard, Amex",
    paypalAccount: "PayPal Account",
    checkDevice: "Check your device",
    checkDeviceDesc: "Before completing your purchase, make sure your device supports eSIM.",
    verifyingPayment: "Verifying payment...",
    verifyingPaymentDesc: "Please wait, we're verifying your payment",
    paymentCompleted: "Payment Completed!",
    processingPaypal: "Processing PayPal payment...",
    total: "Total",
    needInvoice: "Need an invoice?",
    invoiceEntity: "Invoice from:",
    companyName: "Company / Full Name",
    invoiceAddress: "Billing Address"
  },
  footer: {
    tagline: "Your gateway to global connectivity",
    quickLinks: "Quick Links",
    support: "Support",
    legal: "Legal",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    refund: "Refund Policy",
    copyright: "All rights reserved",
    locations: "Our Locations",
    euHQ: "European Headquarters",
    usHQ: "U.S. Headquarters",
    serviceBy: "A service by"
  },
  common: {
    loading: "Loading...",
    error: "Something went wrong",
    success: "Success!",
    close: "Close",
    back: "Back",
    next: "Next",
    search: "Search",
    or: "OR",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    confirm: "Confirm",
    noResults: "No results found",
    optional: "optional"
  },
  auth: {
    welcomeBack: "Welcome Back",
    createAccount: "Create Account",
    signIn: "Sign In",
    signUp: "Sign Up",
    signInDesc: "Sign in to manage your eSIMs",
    signUpDesc: "Join eSIM4You today",
    continueGoogle: "Continue with Google",
    forgotPassword: "Forgot password?",
    fullName: "Full name",
    email: "Email",
    password: "Password",
    backToSignIn: "Back to Sign In",
    resetPassword: "Reset Password",
    sendResetCode: "Send Reset Code",
    checkEmail: "Check your email",
    resetCodeSent: "We sent a reset code to",
    enterEmail: "Enter your email to receive a reset code",
    enterResetCode: "Enter reset code",
    newPassword: "New password",
    passwordReset: "Password Reset!",
    passwordResetSuccess: "Your password has been reset successfully. You can now sign in.",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?"
  },
  about: {
    title: "About",
    subtitle: "We're on a mission to make international connectivity simple, affordable, and instant. No more expensive roaming charges or hunting for local SIM cards.",
    stats: {
      destinations: "Destinations",
      customers: "Customers",
      networkSpeed: "Network Speed",
      support: "Support"
    },
    storyTitle: "Our Story",
    storyP1: "eSIM4You was born from a simple frustration: why is staying connected while traveling still so complicated and expensive? Founded by TelcaVoIP International EU, a European telecommunications company with deep roots in VoIP and connectivity solutions, we set out to change that.",
    storyP2: "Based in Europe with operations in both the EU and the US, we leverage our telecom expertise and partnerships with over 200 mobile operators worldwide to offer eSIM data plans that are affordable, reliable, and delivered in seconds.",
    storyP3: "Whether you're a business traveler hopping between cities, a digital nomad exploring new countries, or a family on vacation — we make sure you're always connected. No SIM swapping, no store visits, no hassle.",
    valuesTitle: "Why Choose Us",
    values: {
      connectivity: { title: "Global Connectivity", desc: "We partner with top-tier mobile operators worldwide to deliver reliable data coverage in over 200 destinations across all continents." },
      delivery: { title: "Instant Delivery", desc: "No waiting, no shipping. Your eSIM is delivered digitally within seconds of purchase. Scan the QR code and you're connected." },
      secure: { title: "Secure & Transparent", desc: "EU-based company with GDPR compliance. Transparent pricing with no hidden fees. Secure payments via Stripe and PayPal." },
      customer: { title: "Customer First", desc: "From device compatibility checks to installation guides, we ensure every step of your journey is seamless and supported." }
    },
    testimonialsTitle: "What Our Customers Say",
    testimonials: {
      t1: { name: "Marco R.", location: "Milan, IT", text: "Fantastic! I bought an eSIM for Japan and in 2 minutes I was connected. Unbeatable prices compared to roaming." },
      t2: { name: "Sarah K.", location: "Berlin, DE", text: "Super easy to set up. Used it across 5 European countries without any issues. Will definitely use again!" },
      t3: { name: "Pierre L.", location: "Paris, FR", text: "Excellent service. The QR code arrived instantly and the installation guide was very clear. Highly recommended." },
      t4: { name: "Anna W.", location: "Warsaw, PL", text: "Finally a reliable eSIM provider in Europe! Used it in Thailand and it worked perfectly. Great customer support too." }
    },
    companyTitle: "TelcaVoIP International EU",
    companySubtitle: "European Telecommunications Company",
    companyLocations: "EU Headquarters | US Operations",
    poweredBy: "Powered by TelcaVoIP.AI"
  },
  chatbot: {
    title: "TelcaVoIP eSIM Support",
    subtitle: "Instant answers",
    welcome: "Hi! I'm the TelcaVoIP eSIM assistant. How can I help you today? Choose a topic below or type your question.",
    whatElse: "What else can I help with?",
    inputPlaceholder: "Type your question...",
    allTopics: "All topics",
    fallback: "I'm sorry, I don't have an answer for that question. Please contact our support team:",
    technician: "A technician will respond shortly. Please include your order number if applicable.",
    categories: {
      installation: "Installation",
      compatibility: "Compatibility",
      orders: "Orders & Delivery",
      coverage: "Coverage & Data",
      refunds: "Refunds & Support"
    },
    faq: {
      installHow: { q: "How do I install an eSIM?", a: "After purchase, you'll receive a QR code via email.\n\n**iPhone:** Settings > Cellular > Add eSIM > Scan QR Code\n**Android:** Settings > Network > SIM > Add eSIM > Scan QR Code\n\nRemember to enable Data Roaming when you arrive at your destination." },
      installWhen: { q: "When should I install the eSIM?", a: "You can install it anytime before your trip. We recommend installing it **before departure** while connected to WiFi. You can then activate it when you arrive at your destination." },
      installMultiple: { q: "Can I install the eSIM on multiple devices?", a: "No, each eSIM QR code can only be installed on **one device**. Once installed, it cannot be transferred to another device." },
      compatible: { q: "Is my device compatible with eSIM?", a: "Most modern smartphones support eSIM, including:\n- **iPhone** XR and later\n- **Samsung** Galaxy S20 and later\n- **Google** Pixel 3 and later\n\nUse our **Compatibility Checker** tool to verify your specific device." },
      phoneCase: { q: "Does eSIM work with my phone case?", a: "Yes! eSIM is a digital SIM — there's no physical card. It works regardless of your phone case or accessories." },
      dualSim: { q: "Can I use eSIM and my regular SIM at the same time?", a: "Yes! Most eSIM-compatible devices support **Dual SIM** (physical SIM + eSIM). You can keep your regular number active while using the eSIM for data abroad." },
      deliveryTime: { q: "How quickly will I receive my eSIM?", a: "eSIMs are delivered **instantly** via email after payment. Check your inbox (and spam folder) for the QR code. You can also find it in your account under \"My eSIMs\"." },
      noEmail: { q: "I didn't receive my eSIM email", a: "Please check your **spam/junk folder** first. If you still can't find it:\n1. Log in to your account\n2. Go to \"My eSIMs\" tab\n3. Contact support with your order number" },
      paymentMethods: { q: "What payment methods do you accept?", a: "We accept:\n- **Credit/Debit Cards** (Visa, Mastercard, Amex) via Stripe\n- **PayPal**\n\nAll payments are processed securely." },
      speeds: { q: "What speeds can I expect?", a: "Our eSIMs support **4G/LTE** and **5G** networks (where available). Actual speeds depend on the local network conditions and your device capabilities." },
      dataRunsOut: { q: "What happens when my data runs out?", a: "When your data allowance is used up, the eSIM will stop providing data. You can purchase a new plan from our website. Some plans offer unlimited data with reduced speeds after the high-speed allowance." },
      phoneCalls: { q: "Can I make phone calls with eSIM?", a: "Our eSIM plans are **data-only**. You can make calls using apps like WhatsApp, FaceTime, Skype, or Zoom over the data connection. For traditional calls, use your regular SIM." },
      refund: { q: "Can I get a refund?", a: "- **Before activation:** Full refund within 14 days\n- **After activation:** Refunds not available (digital product consumed)\n- **Technical issues:** Contact support for troubleshooting or replacement" },
      notWorking: { q: "My eSIM is not working", a: "Try these steps:\n1. Ensure **Data Roaming** is enabled\n2. Restart your device\n3. Check you selected the eSIM for mobile data\n4. Verify you're in a covered country\n\nIf issues persist, contact support." },
      contactSupport: { q: "How do I contact support?", a: "You can reach us at:\n- **WhatsApp:** {{WHATSAPP}}\n- Response time: within 24 hours\n\nPlease include your **order number** for faster assistance." }
    }
  },
  compatibility: {
    title: "eSIM Compatibility Check",
    subtitle: "Verify if your device supports eSIM before purchasing",
    searchPlaceholder: "Type your phone brand and model (e.g. iPhone 15, Galaxy S24)...",
    searchDevice: "Search your device...",
    search: "Search",
    selectDevice: "Select Device",
    selectBrand: "Select brand...",
    selectModel: "Select model...",
    compatible: "eSIM Compatible!",
    notCompatible: "Not eSIM Compatible",
    notCompatibleDesc: "This device does not support eSIM. You can still use a physical SIM card for connectivity while traveling.",
    checkAnother: "Check another device",
    checkCompatibility: "Check eSIM Compatibility",
    deviceNotFound: "Device not found in our database",
    deviceNotFoundDesc: "Try selecting your device from the list, or check your device settings for eSIM support.",
    howToCheck: "How to check manually",
    iphoneInstructions: "Settings > General > About > look for \"Available SIM\" or \"eSIM\"",
    androidInstructions: "Settings > Network > SIM cards > look for \"Add eSIM\" or \"Download SIM\"",
    quickCheck: "Quick Check",
    quickCheckDesc: "Dial *#06# — if you see an EID number, your device supports eSIM",
    brandsCount: "Database includes 150+ devices from major brands",
    dualSim: "Dual SIM",
    fiveGReady: "5G Ready"
  },
  account: {
    profile: "Profile",
    orders: "Orders",
    wishlist: "Wishlist",
    esims: "My eSIMs",
    referral: "Referral",
    invoices: "Invoices",
    noInvoices: "No invoices yet",
    noInvoicesDesc: "Request an invoice during checkout and it will appear here.",
    personalInfo: "Personal Information",
    edit: "Edit",
    save: "Save",
    logout: "Logout",
    fullName: "Full Name",
    phone: "Phone",
    address: "Address",
    city: "City",
    country: "Country",
    postalCode: "Postal Code",
    email: "Email",
    flashOffers: "Flash Offers",
    flashOffersDesc: "Get notified when prices drop on your destinations",
    noOrders: "No orders yet",
    noOrdersDesc: "Start shopping and your orders will appear here",
    browsePlans: "Browse Plans",
    orderStatus: "Order Status",
    items: "Items",
    orderPlaced: "Order Placed",
    payment: "Payment",
    esimReady: "eSIM Ready",
    active: "Active",
    completed: "Completed",
    processing: "Processing",
    pending: "Pending",
    failed: "Failed",
    emailSent: "Email sent",
    emptyWishlist: "Your wishlist is empty",
    emptyWishlistDesc: "Save your favorite destinations to find them easily later",
    browseDestinations: "Browse Destinations",
    added: "Added",
    noEsims: "No eSIMs yet",
    noEsimsDesc: "After purchasing an eSIM, your plans will appear here",
    installGuide: "eSIM Installation Guide",
    iphoneSteps: ["Go to Settings > Cellular", "Tap \"Add eSIM\" or \"Add Cellular Plan\"", "Scan the QR code from your email", "Follow the on-screen instructions", "Enable \"Data Roaming\" when abroad"],
    androidSteps: ["Go to Settings > Network > SIM cards", "Tap \"Add eSIM\" or \"Download SIM\"", "Scan the QR code from your email", "Confirm the download", "Enable \"Data Roaming\" when abroad"],
    qrNote: "QR codes are sent via email after purchase. Check your inbox for the activation email.",
    purchased: "Purchased",
    topup: "Top Up",
    topupTitle: "Top Up eSIM",
    topupDesc: "Add more data to your existing eSIM - no need to reinstall!",
    checkingTopup: "Checking availability...",
    canTopup: "This eSIM can be topped up",
    cannotTopup: "Top-up not available for this eSIM",
    cannotTopupReason: "This eSIM plan does not support direct top-up. This depends on the plan provider. When your data runs out or the plan expires, you can purchase a new eSIM plan from our shop.",
    buyNewPlan: "Buy a new eSIM plan",
    buyNewEsim: "Buy new eSIM",
    buyNewEsimDesc: "Find the perfect plan for your next trip",
    goToShop: "Go to Shop",
    buyAgainFor: "Buy again for:",
    recommendedForYou: "Recommended for you",
    loadingRecommendations: "Loading recommendations...",
    recBuyAgain: "Buy again",
    recPopular: "Popular",
    recTrending: "Trending",
    recFrom: "from",
    recPlans: "plans",
    selectPackage: "Select a data package",
    dataAmount: "Data",
    validity: "Validity",
    days: "days",
    priceLabel: "Price",
    payTopup: "Pay & Top Up",
    topupProcessing: "Processing top-up...",
    topupSuccess: "Top-up applied successfully!",
    topupFailed: "Top-up failed. Please try again.",
    viewQr: "View QR Code",
    hideQr: "Hide QR Code",
    simDetails: "SIM Details",
    loadingDetails: "Loading eSIM details...",
    dataRemaining: "Data Remaining",
    expiresOn: "Expires",
    activePlan: "Active Plan",
    noActivePlan: "No active plan",
    manageEsim: "Manage eSIM",
    backToList: "Back to list",
    copySuccess: "Copied!",
    scanQr: "Scan this QR code to install your eSIM"
  },
  deal: {
    title: "Deal of the Day",
    viewDeal: "View Deal"
  },
  cookie: {
    text: "We use technical cookies necessary for site functionality and analytical cookies to improve your experience. See our",
    privacyPolicy: "Privacy Policy",
    forMoreInfo: "for more information.",
    acceptAll: "Accept all",
    essentialOnly: "Essential only"
  },
  currency: {
    geoDetected: "Currency automatically set to {{symbol}} {{code}} based on your location",
    change: "Change"
  },
  roamingCalc: {
    title: "Roaming Savings Calculator",
    subtitle: "Discover how much you can save with an eSIM compared to your carrier's roaming. Enter your data and compare!",
    yourOperator: "Your operator",
    selectOperator: "Select operator",
    destination: "Destination",
    selectDestination: "Select destination",
    dataQuestion: "How many GB do you plan to use?",
    calculateSavings: "Calculate Savings",
    withEsimSave: "With eSIM you save",
    estimatedCost: "Estimated cost",
    pricePerGB: "Price per GB",
    plannedData: "Planned data",
    total: "Total",
    esimPlan: "eSIM Plan",
    quantity: "Quantity",
    totalData: "Total data",
    buy: "Buy",
    disclaimer: "* Roaming prices are estimates based on average carrier rates. Actual costs may vary. Always check with your carrier before traveling.",
    avgSavings: "Average savings",
    activation: "Activation",
    instant: "Instant",
    coverage: "Coverage",
    countries: "countries",
    otherOperator: "Other operator",
    other: "Other",
    countryIT: "Italy", countryDE: "Germany", countryFR: "France", countryES: "Spain",
    countryPL: "Poland", countryGB: "United Kingdom", countryUS: "United States", countryXX: "Other",
    destItaly: "Italy", destFrance: "France", destGermany: "Germany", destSpain: "Spain",
    destPoland: "Poland", destUK: "United Kingdom", destUSA: "United States",
    destJapan: "Japan", destThailand: "Thailand", destAustralia: "Australia",
    destEurope: "Europe (30+ countries)", destGlobal: "Global (100+ countries)"
  },
  compare: {
    title: "Compare eSIM Plans",
    backToShop: "Back to Shop",
    addMore: "Add More Plans",
    selectAtLeast: "Select at least 2 plans to compare",
    selectAtLeastDesc: "Go back to shop and click the compare icon on products",
    browseMore: "Browse eSIM Plans",
    plansSelected: "plans selected",
    planSelected: "plan selected",
    clearAll: "Clear all",
    compareNow: "Compare Now",
    price: "Price",
    data: "Data",
    validity: "Validity",
    pricePerGB: "Price per GB",
    pricePerDay: "Price per Day",
    coverage: "Coverage",
    network: "Network",
    recommendation: "Our Recommendation",
    recommendationText: "Based on value for money,",
    bestValue: "Best Value",
    lowest: "Lowest",
    mostData: "Most Data",
    forMaxData: "For maximum data, consider"
  },
  productDetail: {
    backToShop: "Back to Shop",
    affordablePlans: "Affordable plans from",
    keepNumber: "Keep your number",
    instantQR: "Instant QR code delivery",
    shareableHotspot: "Shareable hotspot",
    fixed: "Fixed",
    unlimited: "Unlimited",
    sort: "Sort",
    default: "Default",
    cheapest: "Cheapest",
    byData: "By Data",
    addToCart: "Add to Cart",
    selectPlan: "Select a plan"
  },
  legal: {
    lastUpdated: "Last updated: March 2026 | eSIM4You by TelcaVoIP International EU",
    terms: {
      title: "Terms & Conditions",
      s1: { title: "1. General", text: "These Terms and Conditions govern the purchase and use of eSIM products sold through esim4you.com, operated by TelcaVoIP International EU. By placing an order, you agree to be bound by these terms." },
      s2: { title: "2. Products & Services", text: "We sell digital eSIM data plans for international travel. eSIMs are delivered digitally via QR code to your registered email address. Plans include specifications for data allowance, validity period, and supported countries as described on the product page." },
      s3: { title: "3. Device Compatibility", text: "It is the customer's responsibility to verify their device supports eSIM before purchasing. We provide a compatibility checker tool on our website. We are not liable for purchases made for incompatible devices." },
      s4: { title: "4. Pricing & Payment", text: "All prices are displayed in EUR and include applicable taxes. We accept payment via credit/debit card (Stripe) and PayPal. Payment is processed at the time of purchase. The eSIM is delivered after successful payment confirmation." },
      s5: { title: "5. Delivery", text: "eSIMs are digital products delivered instantly via email after payment. You will receive a QR code with installation instructions. No physical shipping is involved. Delivery times may vary by a few minutes depending on email processing." },
      s6: { title: "6. Refund Policy", text: "Due to the digital nature of eSIM products:", items: ["Before activation: Full refund available within 14 days of purchase", "After activation: Refunds are not available once the eSIM has been installed and activated on a device", "Technical issues: If you experience connectivity problems, contact support for assistance or replacement"], refundContact: "To request a refund, contact" },
      s7: { title: "7. Right of Withdrawal (EU)", text: "Under EU consumer protection law, you have the right to withdraw from the purchase within 14 days. However, by proceeding with the purchase and requesting immediate delivery of the digital eSIM, you acknowledge and agree that you waive your right of withdrawal once the eSIM has been delivered and/or activated." },
      s8: { title: "8. Limitation of Liability", text: "eSIM4You is not liable for network outages, speed limitations, or coverage issues caused by third-party mobile network operators. We provide connectivity through partner networks and cannot guarantee uninterrupted service in all conditions." },
      s9: { title: "9. Contact", text: "TelcaVoIP International EU" }
    },
    privacy: {
      title: "Privacy Policy",
      s1: { title: "1. Data Controller", text: "TelcaVoIP International EU is the data controller for personal data collected through esim4you.com, in compliance with the EU General Data Protection Regulation (GDPR)." },
      s2: { title: "2. Data We Collect", items: ["Account data: Name, email address, password (hashed)", "Billing data: Name, address, phone number (for order processing)", "Payment data: Processed securely by Stripe and PayPal (we do not store card numbers)", "Usage data: Pages visited, device type, browser (anonymous analytics)"] },
      s3: { title: "3. Purpose of Processing", items: ["Process and deliver your eSIM orders", "Send order confirmations and eSIM delivery emails", "Manage your user account and wishlist", "Provide customer support", "Comply with legal obligations"] },
      s4: { title: "4. Legal Basis (GDPR Art. 6)", items: ["Contract: Processing necessary for order fulfillment", "Consent: For marketing emails and analytics cookies", "Legitimate interest: For fraud prevention and service improvement"] },
      s5: { title: "5. Third-Party Services", items: ["Stripe: Payment processing (PCI-DSS compliant)", "PayPal: Payment processing", "Resend: Transactional email delivery", "Google: Social login authentication"], note: "These services process data in accordance with their own privacy policies and are GDPR compliant." },
      s6: { title: "6. Your Rights (GDPR)", intro: "As an EU resident, you have the right to:", items: ["Access your personal data", "Rectify inaccurate data", "Request erasure (\"right to be forgotten\")", "Restrict or object to processing", "Data portability", "Withdraw consent at any time"], contact: "To exercise these rights, contact:" },
      s7: { title: "7. Cookies", text: "We use essential cookies for site functionality (authentication, cart) and optional analytics cookies. You can manage your preferences via the cookie banner or your browser settings." },
      s8: { title: "8. Data Retention", text: "Account data is retained as long as your account is active. Order data is retained for 10 years as required by EU tax law. You can request account deletion at any time." },
      s9: { title: "9. Contact", text: "Data Protection Officer\nTelcaVoIP International EU\nEmail: privacy@esim4you.com" }
    },
    refund: {
      title: "Refund Policy",
      beforeActivation: { title: "Before Activation", text: "If your eSIM has not been activated (not installed on a device), you are eligible for a full refund within 14 days of purchase." },
      afterActivation: { title: "After Activation", text: "Once the eSIM has been installed and activated on a device, refunds are not available as the digital product has been consumed. This is in accordance with EU Digital Content Directive (2019/770)." },
      technicalIssues: { title: "Technical Issues", text: "If you experience connectivity problems or technical issues with your eSIM, please contact our support team. We will:", items: ["Troubleshoot the issue within 24 hours", "Provide a replacement eSIM if the issue cannot be resolved", "Issue a full refund if no working solution can be provided"] },
      howToRequest: { title: "How to Request a Refund", text: "Send an email to", with: "with:", items: ["Your order number", "Email address used for the purchase", "Reason for the refund request"], processing: "Refunds are processed within 5-10 business days to the original payment method." }
    }
  },
  review: {
    title: "Share Your Experience",
    subtitle: "Help fellow travelers by sharing your eSIM experience",
    ratingLabel: "Rating",
    textLabel: "Your review",
    placeholder: "How was your eSIM experience? Connection quality, speed, ease of setup...",
    submit: "Submit Review",
    maybeLater: "Maybe Later",
    thankYou: "Thank you!",
    published: "Your review has been published and will help other travelers.",
    continueBrowsing: "Continue Browsing",
    invalidLink: "This review link is invalid or has already been used.",
    rating5: "Amazing!",
    rating4: "Great!",
    rating3: "Good",
    rating2: "Fair",
    rating1: "Poor",
    yourReward: "Your Reward",
    nextPurchase: "your next purchase",
    couponNote: "Valid for 30 days, single use. Enter at checkout."
  },
  referral: {
    title: "Invite Friends, Earn Rewards",
    subtitle: "Share your link: your friend gets 10% off, you earn €2 credit!",
    yourLink: "Your Referral Link",
    shareText: "Get 10% off your first eSIM purchase with my referral link!",
    step1: "Share your link",
    step2: "Friend gets 10% off",
    step3: "You earn €2 credit",
    invited: "Invited",
    clicks: "Clicks",
    purchases: "Purchases",
    rewards: "Rewards",
    activeCoupons: "Active Coupons",
    recentReferrals: "Recent Referrals",
    yourRewards: "Your Reward Coupons",
    rewardAmount: "€2 credit",
    purchased: "Purchased",
    signedUp: "Signed up"
  },
  tripPlanner: {
    badge: "Trip Planner",
    title: "Plan Your Trip",
    subtitle: "Enter your itinerary stops and we'll find the optimal eSIM plan for each destination",
    destinations: "Trip Stops",
    firstStop: "First stop (e.g. Rome)",
    lastStop: "Last stop (e.g. London)",
    middleStop: "Middle stop (e.g. Paris)",
    addStop: "Add stop",
    daysPerStop: "Days per stop",
    dataNeed: "Data usage",
    findBestPlans: "Find Best Plans",
    optimizing: "Optimizing...",
    yourItinerary: "Your Itinerary",
    stops: "stops",
    notFound: "Destination not found in catalog",
    plansAvailable: "plans",
    bundleTotal: "Bundle Total",
    daysEach: "days/stop",
    addAllToCart: "Add All to Cart",
    goToCheckout: "Go to Checkout",
    addedAll: "${added} eSIMs added to cart!",
    minDestinations: "Enter at least 2 destinations",
    error: "Optimization error"
  }
};

export default en;
